import { ContactMasterData } from "types/models/contactMaster/ContactMasterApp";

export const GET_CONTACT = "GET_CONTACT";
export const SET_CONTACT_DATA = "SET_CONTACT_DATA";
export const CREATE_CONTACT = "CREATE_CONTACT";
export const RESET_CONTACT_DATA = "RESET_CONTACT_DATA";

export const UPDATE_CONTACT = "UPDATE_CONTACT";

export interface GetContactAction {
  type: typeof GET_CONTACT;
  payload: { data: ContactMasterData[]; total: number };
}

export interface SetContactDetailAction {
  type: typeof SET_CONTACT_DATA;
  payload: ContactMasterData;
}
export interface createContact{
  type: typeof CREATE_CONTACT;
    payload: any; 
}
export interface updateContact{
  type: typeof UPDATE_CONTACT;
    payload: any; 
}
export interface ResetContact{
  type: typeof RESET_CONTACT_DATA;
}

export type ContactMasterActionTypes =
  | GetContactAction
  | SetContactDetailAction
  | createContact
  |updateContact
  |ResetContact
